import axios from 'axios';

const ACCESS_TOKEN_EXPIRED = 'access_token_expired';
const JWT_TOKEN_NOT_FOUND = 'JWT Token not found';
const REFRESH_TOKEN_PATH = '/open-api/auth/refresh-token';

let refreshTokenRequest: Promise<void> | null = null;

type TokenErrorPayload = {
  code?: number;
  error?: string;
  message?: string;
};

type ResponseErrorPayload = {
  response?: {
    status?: number;
    data?: TokenErrorPayload;
  };
};

export function isAccessTokenExpired(
  status?: number,
  payload?: TokenErrorPayload,
) {
  return (
    status === 401 ||
    payload?.code === 401 ||
    payload?.error === ACCESS_TOKEN_EXPIRED ||
    payload?.message === JWT_TOKEN_NOT_FOUND
  );
}

export function isAccessTokenExpiredResponseError(error: ResponseErrorPayload) {
  return isAccessTokenExpired(error?.response?.status, error?.response?.data);
}

function buildRefreshTokenUrl(baseURL?: string) {
  const refreshTokenBaseURL = process.env.REACT_APP_VMP_URL || baseURL || '';
  if (!refreshTokenBaseURL) return REFRESH_TOKEN_PATH;

  return `${refreshTokenBaseURL.replace(/\/$/, '')}${REFRESH_TOKEN_PATH}`;
}

export function refreshAccessToken(baseURL?: string) {
  if (!refreshTokenRequest) {
    refreshTokenRequest = axios
      .post(
        buildRefreshTokenUrl(baseURL),
        {},
        {
          timeout: 30000,
          withCredentials: true,
        },
      )
      .then(() => undefined)
      .catch((error: any) => {
        if (
          error?.response?.status !== 200 &&
          typeof window !== 'undefined' &&
          window.location.pathname !== '/login'
        ) {
          [
            'driver-portal-access-token',
            'driver-portal-refresh-token',
            'driver-portal-google-linked',
            'driver-portal-user-id',
            'driver-portal-potential-lead-id',
            'sub',
            'driver-portal-user-tel',
            'driver-portal-profile',
          ].forEach(key => localStorage.removeItem(key));
          window.location.href = '/login';
        }
        return Promise.reject(error);
      })
      .finally(() => {
        refreshTokenRequest = null;
      });
  }

  return refreshTokenRequest;
}
